export const ConnectNotice = ({i18n, links}) => {
    return (
        <div className="stripe-not-connected">
            <div className="stripe-not-connected__card">

                <div className="stripe-not-connected__icon" aria-hidden="true">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect x="2" y="6" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="1.5"/>
                        <path d="M2 10h20" stroke="currentColor" strokeWidth="1.5"/>
                        <path d="M6 15h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                    </svg>
                </div>

                <h2 className="stripe-not-connected__heading">
                    {i18n.connectAccount}
                </h2>

                <p className="stripe-not-connected__description">
                    {i18n.addAPIKeys}
                </p>

                <div className="stripe-not-connected__actions">
                    <a
                        className="stripe-not-connected__primary-btn"
                        href={links.settings}
                    >
                        {i18n.goToSettings}
                        <svg width="12" height="12" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                            <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
                                  strokeLinejoin="round"/>
                        </svg>
                    </a>

                    {links.documentatio && (
                        <a
                            href={links.documentation}
                            target="_blank"
                            rel="noreferrer"
                            className="stripe-not-connected__docs-link"
                        >
                            {i18n.configGuide}
                            <svg width="9" height="9" viewBox="0 0 10 10" fill="none" aria-hidden="true">
                                <path d="M2 8l6-6M8 8V2H2" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"
                                      strokeLinejoin="round"/>
                            </svg>
                        </a>
                    )}
                </div>

            </div>
        </div>
    )
}

export default ConnectNotice;